<template>
  <v-layout justify-center align-center fill-height pl-2 pt-4 pr-2 pb-2 row>
    <v-flex xs12 sm10 md9 lg7 pl-2>
      <SimpleCard>
        <v-layout row wrap>
          <v-flex xs12>
            <h2>Edit User</h2>
          </v-flex>
          <v-flex xs12 md12>
            <UserForm
              v-if="!loading"
              ref="userForm"
              :disabled="disabled"
              :user="user"
              :errors="errors"
              @validityChange="updateFormValidity($event)"
              :editingUser="true"
            />
            <v-divider class="mx-1"></v-divider>
          </v-flex>
          <v-flex xs12 md12 pt-1>
            <v-layout align-center justify-end row>
              <v-btn color="success" @click="update" class="text-none" :disabled="disabled">Update</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </SimpleCard>
    </v-flex>
    <v-snackbar v-model="snackbarShow" :color="snackbarColour" :timeout="4000">{{ snackbarMessage }}</v-snackbar>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import UserForm from "@/components/customer/UserForm.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "edit_customer",
  components: {
    SimpleCard,
    UserForm
  },
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      user: null,
      errors: {},
      userFormValid: false,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null,
      loading: true,
      disabled: false
    };
  },
  mounted: function() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo: async function() {
      this.disabled = true;
      let self = this;
      let url = `${this.$store.state.apiUrl}/customer/${this.$route.params.id}/get`;

      axios
        .get(url)
        .then(function(response) {
          if (!response.error) {
            if (response.data.user) {
              self.disabled = false;
              self.user = response.data.user;
            } else {
              self.user = {};
              self.snackbarMessage = "Error fetching customer, no user data";
              self.snackbarColour = "error";
              self.snackbarShow = true;
            }
          } else {
            console.log(response.error);
            self.user = {};
            self.snackbarMessage = "Error fetching customer: " + response.error;
            self.snackbarColour = "error";
            self.snackbarShow = true;
          }
          self.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          self.user = {};
          self.snackbarMessage = error;
          self.snackbarColour = "error";
          self.snackbarShow = true;
          self.loading = false;
        });
    },
    update: async function() {
      delete this.user["loyalty_tier"];
      delete this.user["loyalty_point_summary"];

      if (this.userFormValid) {
        let self = this;
        let url = `${this.$store.state.apiUrl}/customer/${this.$route.params.id}/update`;
        axios({
          url: url,
          method: "post",
          data: {
            user: this.user
          },
          headers: {
            "Content-Type": "text/plain"
          }
        })
          .then(function(response) {
            console.log(response.data.errors);
            if (response.data.errors) {
              self.errors = response.data.errors;
              self.snackbarMessage =
                "Error updating customer, please check the form";
              self.snackbarColour = "error";
              self.snackbarShow = true;
            } else if (response.data.error != "no_error") {
              self.snackbarMessage =
                "Error updating customer: " + response.data.error;
              self.snackbarColour = "error";
              self.snackbarShow = true;
              console.log(response.data.error);
            } else {
              if (self.embedded) {
                self.$emit("userUpdated", self.user);
              } else {
                const userID = response.data.user.id;
                self.$router.push("../../customer/view/" + userID);
              }
            }
          })
          .catch(function(error) {
            console.log(error);
            self.snackbarMessage = "Network error: " + error;
            self.snackbarColour = "error";
            self.snackbarShow = true;
          });
      } else {
        this.snackbarMessage = "Please complete the form before submitting";
        this.snackbarColour = "error";
        this.snackbarShow = true;
        this.$refs.userForm.validateForm();
      }
    },
    updateFormValidity: function(value) {
      this.userFormValid = value;
    }
  }
};
</script>